import { combineAllReducers, ReducerTree } from '@mode/legacy/util-domain';
import { Actions as AppActions } from '~/actions';
import { SharedChartCommandActionType } from '~/actions/chart-commands/shared.actions';
import { RouterActionType } from '~/actions/router-actions';

import { ViewDataModalFeature, ViewDataModalState } from '@mode/shared/contract-common';
import { createReducer, on } from '@mode/legacy/util-domain';
import { ViewDataModalActions as Actions } from '@mode/reports/domain';

export const initialViewDataModalState: ViewDataModalState = {
  encoding: null,
  isOpen: false,
  queryToken: null,
  seriesDetail: null,
  title: null,
  paging: {
    offset: 0,
    pageSize: 100,
  },
};

// This is an older-style reducer because it references old actions
function isOpenReducer(state = initialViewDataModalState.isOpen, action: AppActions) {
  switch (action.type) {
    case Actions.openModal.type:
      return true;

    case Actions.closeModal.type:
    case SharedChartCommandActionType.CloseAllModals:
    case RouterActionType.UpdateRoute:
      return false;
    default:
      return state;
  }
}

const encodingReducer = createReducer(
  initialViewDataModalState.encoding,
  on(Actions.openModal, (state, action) => action.encoding),
  on(Actions.closeModal, (state, action) => null)
);

const seriesDetailReducer = createReducer(
  initialViewDataModalState.seriesDetail,
  on(Actions.openModal, (state, action) => action.seriesDetail),
  on(Actions.closeModal, (state, action) => null)
);

const queryTokenReducer = createReducer(
  initialViewDataModalState.queryToken,
  on(Actions.openModal, (state, action) => action.queryToken),
  on(Actions.closeModal, (state, action) => null)
);

const titleReducer = createReducer(
  initialViewDataModalState.title,
  on(Actions.openModal, (state, action) => action.title),
  on(Actions.closeModal, (state, action) => null)
);

const pagingReducer = createReducer(
  initialViewDataModalState.paging,
  on(Actions.setOffset, (state, action) => ({
    ...state,
    offset: action.offset,
  })),
  on(Actions.openModal, (state) => initialViewDataModalState.paging)
);

export const viewDataModalReducers: ReducerTree<any, ViewDataModalState, AppActions> = {
  isOpen: isOpenReducer,
  encoding: encodingReducer,
  seriesDetail: seriesDetailReducer,
  queryToken: queryTokenReducer,
  title: titleReducer,
  paging: pagingReducer,
};

export const viewDataModalReducer = combineAllReducers<ViewDataModalFeature, keyof ViewDataModalFeature, AppActions>({
  viewDataModal: viewDataModalReducers,
});
